import firebase from "firebase/app";
import "firebase/functions";

export async function validateUniqueGmail(
  gmail: string,
  excludeUserDocPath?: string
): Promise<boolean> {
  const call = firebase
    .app()
    .functions("asia-northeast1")
    .httpsCallable("check_role_identifier_available");
  const res = await call({ kind: "gmail", value: gmail, excludeUserDocPath });
  return res.data.available;
}

export async function validateUniqueMicrosoftEmail(
  microsoftEmail: string,
  excludeUserDocPath?: string
): Promise<boolean> {
  const call = firebase
    .app()
    .functions("asia-northeast1")
    .httpsCallable("check_role_identifier_available");
  const res = await call({
    kind: "microsoftEmail",
    value: microsoftEmail,
    excludeUserDocPath
  });
  return res.data.available;
}

export async function updateExternalServiceEmail(
  type: "google" | "microsoft",
  email: string
) {
  if (type !== "google" && type !== "microsoft") return;
  const call = firebase
    .app()
    .functions("asia-northeast1")
    .httpsCallable("update_external_service_email");
  await call({ type, email });
}
